import { memo, useMemo, useCallback } from 'react';

import { BankAccountView } from 'models';

import useDispatch from 'shared/hooks/useDispatch';
import useSelector from 'shared/hooks/useSelector';

import { selectDefaultBankAccounts } from 'features/bank-accounts/selectors';
import { selectBankAccount } from 'features/purchase-invoices/selectors';
import { setBankAccount } from 'features/purchase-invoices/slice';

import { CustomSelect } from 'components';

import { useStyles } from './BankAccountsSelect.style';

const DEFAULT_BANK_ACCOUNT: BankAccountView = {
  Balance: null,
  BalanceDate: null,
  Cooperative: null,
  CooperativeIds: [],
  Description: null,
  Id: 'All',
  IsMain: null,
  LogicalName: null,
  Number: 'Kaikki pankkitilit',
  ModifiedOn: '',
  Operator: null,
};

const BankAccountsSelect = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const bankAccounts = useSelector(selectDefaultBankAccounts);
  const selectedBankAccount = useSelector(selectBankAccount);

  const mobileSelectCls = useMemo(
    () => ({
      outputWrapper: classes.mobileSelect,
    }),
    [classes]
  );

  const renderItem = (bankAccount: BankAccountView) => {
    return (
      <div className={classes.selectItem}>
        <span className={classes.accountNumber}>{bankAccount.Number}</span>
        <span className={classes.operatorName}>
          {bankAccount.Operator?.Name}
        </span>
      </div>
    );
  };

  const renderValue = (bankAccount: BankAccountView) => {
    return <span className={classes.output}>{bankAccount.Number}</span>;
  };

  const handleChangeBankAccount = (bankAccount: BankAccountView) => {
    dispatch(setBankAccount(bankAccount));
  };

  const isItemActive = useCallback(
    (bankAccount: BankAccountView) => {
      return bankAccount.Id === selectedBankAccount.Id;
    },
    [selectedBankAccount]
  );

  const bankAccountsOptions = useMemo(() => {
    return [DEFAULT_BANK_ACCOUNT].concat(bankAccounts);
  }, [bankAccounts]);

  return (
    <CustomSelect
      value={selectedBankAccount}
      options={bankAccountsOptions}
      onChange={handleChangeBankAccount}
      renderValue={renderValue}
      renderItem={renderItem}
      isActive={isItemActive}
      cls={mobileSelectCls}
    />
  );
};

export default memo(BankAccountsSelect);
